import { apiEmpleo } from "../../util/ApiEmpleo"

export type IGetEmployer = {
  id: string;
  DNI?: string;
  Name?: string;
  Nombre?: string;
  Email?: string;
  Nombre_y_Apellidos_Empleador?: string;
  Primer_Apellido?: string;
  createdAt: string;
  zohoId?: string;
}

const apiGetEmployer = async (employerId: string) => {
  let res: IGetEmployer = await apiEmpleo.get(
    `employers/${employerId}`
  );

  return res;
}

export { apiGetEmployer };